"use client";
import React from "react";
import { Modal } from "react-bootstrap";
import privacy from "../../public/assets/images/pricing/privacy.png";
import CommonButton from "./CommonButton";
import Image from "next/image";

const ExitModal = ({ show, onHide, exitBtn }) => {
  return (
    <Modal
      backdrop="static"
      keyboard={false}
      show={show}
      onHide={onHide}
      centered
      className="exit-confirmation-modal"
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title>
          Your privacy matters —<span>and we respect that</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-0">
        <Image
          src={privacy}
          alt={"privacy"}
          height={300}
          width={300}
          className="img-fluid mx-auto d-block"
        />
        <p className="text-center p-0 m-0">
          But checking our offerings are essential. Trust that,
        </p>
        <p className="text-center p-0 m-0">
          <strong>No spam. No pressure.</strong>
        </p>
        {/* <p className="text-center">
          Just your custom quote — saved securely, for when you’re ready.
        </p> */}
        <div className="d-flex justify-content-center gap-3 mt-4">
          <CommonButton
            label="Cancel"
            className="black-border"
            variant="outline"
            onClick={onHide}
          />
          <CommonButton
            label="Exit"
            className="btn-primary"
            onClick={exitBtn}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ExitModal;
